import React from "react";
import './App.css';
//import moviesData from './moviesData.js';
import { API_URL, API_KEY_3 } from "./utils/api.js";
import MovieItem from "./MovieItem.js";
import MovieTabs from "./MovieTabs.js";
import "bootstrap/dist/css/bootstrap.min.css";

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      //movies: moviesData,
      movies: [],
      moviesWillWatch: [],
      sort_by: "popularity.desc",
      page: 1
    };
  }

  /////// for API
  //ComponentDidMount - for initialize data (view)
  componentDidMount() {
    console.log("didMount");
    //fetch('https://api.themoviedb.org/3/discover/movie?api_key=32044039455e2188ce91364820cf17a3')
    this.getMovies();
  }
  /////

  //Switcher
  //switchPage = page => {
  //const nextPage = [...this.state.moviesNextPage, page++];
  //this.setState({
  //moviesNextPage: nextPage
  //})
  //console.log(moviesNextPage);
  //}

  nextPage = () => {
    this.setState({
      page: this.state.page + 1
    });
  };

  prevPage = () => {
    this.setState({
      page: this.state.page - 1
    },
    () => {
      this.limiter();
    }
    );
    console.log("prev", this.state.page);
  };

  limiter = () => {
    if (this.state.page === 0) {
      alert("No more pages");
    }
  };

  getMovies = () => {
    fetch(
      `${API_URL}/discover/movie?api_key=${API_KEY_3}&sort_by=${
        this.state.sort_by
      }&page=${this.state.page}`
    )
      .then(response => {
        console.log("then");
        return response.json();
      })
      .then(data => {
        console.log("data", data);
        this.setState({
          //http://i.piccy.info/i9/c9535f24d31eb2ff5fdbbc9de0ef55ac/1583765514/68670/1366598/dataresults.jpg
          movies: data.results,
          page: data.page
        });
      });
  };

  removeMovie = movie => {
    const updateMovies = this.state.movies.filter(function(item) {
      return item.id !== movie.id;
    });
    console.log(updateMovies);
    this.setState({
      movies: updateMovies
    });
  };

  addMovieToWillWatch = movie => {
    const updateMoviesWillWatch = [...this.state.moviesWillWatch, movie];
    this.setState({
      moviesWillWatch: updateMoviesWillWatch
    });
  };

  removeMovieFromWillWatch = movie => {
    const updateMoviesWillWatch = this.state.moviesWillWatch.filter(function(
      item
    ) {
      return item.id !== movie.id;
    });
    this.setState({
      moviesWillWatch: updateMoviesWillWatch
    });
  };

  updateSortBy = value => {
    this.setState({
      sort_by: value
    });
  };

  //for updating state
  componentDidUpdate(prevProps, prevState) {
    console.log("didUpdate");
    console.log("prev", prevProps, prevState);
    console.log("this", this.props, this.state);
    if (
      prevState.sort_by !== this.state.sort_by ||
      prevState.page !== this.state.page
    ) {
      console.log("call api");
      this.getMovies();
    }
  }

  render() {
    console.log("render", this.state.sort_by);
    return (
      <div className="container">
        <div className="row">
          <div className="col-6">
            <div className="row mb-4 mt-4">
              <MovieTabs
                sort_by={this.state.sort_by}
                updateSortBy={this.updateSortBy}
              />
            </div>
            {this.state.movies.map(movie => {
              return (
                <MovieItem
                  key={movie.id}
                  movie={movie}
                  removeMovie={this.removeMovie}
                  addMovieToWillWatch={this.addMovieToWillWatch}
                  removeMovieFromWillWatch={this.removeMovieFromWillWatch}
                />
              );
            })}
            <div>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.prevPage}
              >
                Previous Page
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.nextPage}
              >
                Next Page
              </button>
            </div>
          </div>
          <div className="col-3">
            <p>Will Watch: {this.state.moviesWillWatch.length} </p>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
